import type { CreatorLockedFields } from '@fluenceur/types';

/** What the plan withheld from a payload (a creator, a wishlist row, an application), if anything. */
const lockedOf = (payload: unknown): CreatorLockedFields | null =>
  (payload as { locked?: CreatorLockedFields | null } | null | undefined)?.locked ?? null;

/**
 * Whether the brand's plan withheld this creator's identity (handle, email,
 * name, contact details). The keys are absent from the payload, never blurred:
 * read this rather than guessing from a missing username.
 */
export const isIdentityLocked = (payload: unknown): boolean => !!lockedOf(payload)?.identity;

/** Whether the brand's plan withheld this creator's advanced statistics. */
export const isStatsLocked = (payload: unknown): boolean => !!lockedOf(payload)?.stats;

/**
 * Whether this creator shows in full only because the organization spent one
 * of its monthly profile unlocks on them. Never set for a creator the brand
 * works with, nor on a plan that masks nothing: those carry no marker.
 */
export const isProfileUnlocked = (payload: unknown): boolean =>
  (payload as { unlocked?: boolean } | null | undefined)?.unlocked === true;
